export default [
    {
        path: 'reagendamento-cancelamento-exame',
        component: () => import(
            /* webpackChunkName: 'exame-imagem-reagendamento-cancelamento-exame' */
            '@/views/exame-imagem/reagendamento-cancelamento-exame/Index'
        ),
        redirect: 'reagendamento-cancelamento-exame/index',
        children: [
            {
                name: 'exame-imagem-reagendamento-cancelamento-exame-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'exame-imagem-reagendamento-cancelamento-exame' */
                    '@/views/exame-imagem/reagendamento-cancelamento-exame/List.vue'
                ),
            },
            {
                name: 'exame-imagem-reagendamento-cancelamento-exame-create',
                path: 'create/:id',
                props: route => ({ id: parseInt(route.params.id) }),
                component: () => import(
                    /* webpackChunkName: 'exame-imagem-reagendamento-cancelamento-exame' */
                    '@/views/exame-imagem/reagendamento-cancelamento-exame/Form.vue'
                ),
            },
            {
                component: () => import(
                    /* webpackChunkName: 'exame-imagem-reagendamento-cancelamento-exame' */
                    '@/views/exame-imagem/reagendamento-cancelamento-exame/Form.vue'
                ),
                name: 'exame-imagem-reagendamento-cancelamento-exame-edit',
                path: 'edit/:id',
                props: route => ({id: parseInt(route.params.id)}),
            },
        ],
    },
]